'use strict';

var React = require('react');

var SvgCreditCardPercentIcon = function SvgCreditCardPercentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 4a2.75 2.75 0 0 0-2.75 2.75v6.5a2.75 2.75 0 0 0 2.75 2.75h5.104a.75.75 0 0 0 0-1.5h-5.104c-.69 0-1.25-.56-1.25-1.25v-4h12a.75.75 0 0 0 1.5 0v-2.5a2.75 2.75 0 0 0-2.75-2.75h-9.5Zm10.75 3.25v-.5c0-.69-.56-1.25-1.25-1.25h-9.5c-.69 0-1.25.56-1.25 1.25v.5h12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.47 11.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 1 1-1.06-1.06l4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 11.25a.75.75 0 0 0 0 1.5h2.75a.75.75 0 0 0 0-1.5h-2.75Z"
  }));
};
SvgCreditCardPercentIcon.displayName = "CreditCardPercentIcon";

exports.SvgCreditCardPercentIcon = SvgCreditCardPercentIcon;
